import { render, staticRenderFns } from "./ContentRelevanceList.vue?vue&type=template&id=36c2eb60&scoped=true"
import script from "./ContentRelevanceList.vue?vue&type=script&lang=js"
export * from "./ContentRelevanceList.vue?vue&type=script&lang=js"
import style0 from "./ContentRelevanceList.vue?vue&type=style&index=0&id=36c2eb60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c2eb60",
  null
  
)

export default component.exports